export const alignStyles = {
  vertical: 'space-y-3',
  horizontal:
    'grid grid-cols-2 gap-y-5 lg:flex lg:items-center lg:space-y-0 lg:flex-wrap lg:space-x-12',
}
